import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api, formatINR } from "@/lib/api";
import { useStore } from "@/lib/store";

export default function Account() {
  const { user, logout } = useStore();
  const nav = useNavigate();
  const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (!user) { nav("/auth"); return; }
    api.get("/orders/me").then(r => setOrders(r.data)).catch(() => {});
  }, [user, nav]);

  if (!user) return null;

  return (
    <div data-testid="account-page" className="max-w-[1200px] mx-auto px-6 lg:px-10 py-12">
      <div className="grid grid-cols-1 lg:grid-cols-4 gap-10">
        <aside>
          <div className="eyebrow">Your Aura</div>
          <div className="font-serif-luxe text-3xl text-[#FAF8F5] mt-2">{user.name}</div>
          <div className="text-sm text-[#C2B29F] mt-1">{user.email}</div>
          <div className="mt-8 space-y-3 text-sm">
            <Link to="/wishlist" className="block text-[#FAF8F5] hover:text-[#D4AF37]">Wishlist</Link>
            {user.is_admin && <Link to="/admin" className="block text-[#D4AF37]">Admin Panel</Link>}
            <button onClick={logout} className="text-[#FAF8F5] hover:text-[#D4AF37]">Sign out</button>
          </div>
        </aside>
        <div className="lg:col-span-3">
          <div className="eyebrow">Order History</div>
          <h1 className="font-serif-luxe text-4xl text-[#FAF8F5] mt-2 mb-8">My Orders</h1>
          {orders.length === 0 ? (
            <div className="text-[#C2B29F]">You haven't placed any orders yet.</div>
          ) : (
            <div className="space-y-4">
              {orders.map(o => (
                <Link key={o.id} to={`/order/${o.id}`} className="block bg-[#1C130E] border border-[#D4AF37]/20 p-5 hover:border-[#D4AF37]/50 transition">
                  <div className="flex justify-between items-start">
                    <div>
                      <div className="text-xs tracking-[0.14em] uppercase text-[#C2B29F]">Order #{o.id.slice(0,8).toUpperCase()}</div>
                      <div className="font-serif-luxe text-xl text-[#FAF8F5] mt-1">{o.items.length} item{o.items.length > 1 ? "s" : ""}</div>
                      <div className="text-xs text-[#C2B29F] mt-1">{new Date(o.created_at).toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</div>
                    </div>
                    <div className="text-right">
                      <div className="text-[#D4AF37] font-medium">{formatINR(o.total)}</div>
                      <div className="mt-2 text-[10px] tracking-[0.24em] uppercase text-[#D4AF37] border border-[#D4AF37]/40 px-2 py-1 inline-block">{o.status}</div>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
